import { ORGAN_ACCENTS } from "@/components/OrganLayout";
import OrganConnections from "@/components/OrganConnections";
import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { OrganIcon } from "@/components/Shared";
import { ORGAN_MAP, TOUCH_POSITIONS, organState, coverage } from "@/lib/dadDesign";
import { StatusBadge } from "@/components/DadStatus";

export function OrganHotspot({ organ, record, requestState, active, onActivate }) {
  const [state, label] = organ.id === "mouth" ? ["unknown", "Area in sviluppo · Dati insufficienti"] : organState(record, requestState);
  return <Link to={organ.route} className="dad-hotspot" data-active={active} data-state={state}
    data-testid={`organ-hotspot-${organ.id}`} style={{ "--x": `${organ.x}%`, "--y": `${organ.y}%`, "--touch-x": `${TOUCH_POSITIONS[organ.id][0]}%`, "--touch-y": `${TOUCH_POSITIONS[organ.id][1]}%` }}
    aria-label={`${organ.anatomy} — ${organ.name} — ${label}`}
    onMouseEnter={() => onActivate(organ.id)} onMouseLeave={() => onActivate(null)}
    onFocus={() => onActivate(organ.id)} onBlur={() => onActivate(null)}>
    <span className="dad-hotspot-dot" /><span className="dad-hotspot-label">{organ.anatomy} · {label}</span>
  </Link>;
}
export function OrganStatusCard({ organ, record, requestState, active, onActivate }) {
  const [state, label] = organ.id === "mouth" ? ["unknown", "Area in sviluppo · Dati insufficienti"] : organState(record, requestState);
  const percent = organ.id === "mouth" ? null : coverage(record?.census_coverage);
  return <Link to={organ.route} className="dad-organ-card" style={{"--organ-accent":ORGAN_ACCENTS[organ.id] || "#59dbea"}} data-active={active} data-testid={`organ-card-${organ.id}`}
    onMouseEnter={() => onActivate(organ.id)} onMouseLeave={() => onActivate(null)}
    onFocus={() => onActivate(organ.id)} onBlur={() => onActivate(null)}>
    <span className="dad-organ-icon"><OrganIcon icon={organ.icon} size={20} /></span>
    <span className="dad-organ-copy"><span className="dad-eyebrow">{organ.anatomy}</span><strong>{organ.name}</strong>
      <StatusBadge state={state}>{label}</StatusBadge>
      <span className="dad-organ-coverage">Copertura dati: {percent === null ? "—" : `${Math.round(percent)}%`}{organ.id !== "mouth" && record?.census_qualified ? " · qualificata" : ""}</span>
    </span>
  </Link>;
}
export function HumanBodyMap({ records, requestState, active, onActivate }) {
  const [unavailable, setUnavailable] = useState(false);
  return <div className="dad-body-map" data-mouth-active={active === "mouth"} data-testid="company-organism">
    {!unavailable ? <img src="/assets/dad-organism.jpg" alt="Anatomia umana: mappa delle funzioni aziendali"
      width="848" height="1264" onError={() => setUnavailable(true)} /> :
      <p className="dad-image-error" role="status">Immagine non disponibile. Le card organo rimangono navigabili.</p>}
    {!unavailable && <span className="dad-mouth-glow" aria-hidden="true" />}
    {!unavailable && ORGAN_MAP.map(organ => <OrganHotspot key={organ.id} organ={organ}
      record={records[organ.id]} requestState={requestState} active={active === organ.id} onActivate={onActivate} />)}
  </div>;
}
export default function OrganismHero({ resource }) {
  const [hovered, setHovered] = useState(null); const scene = useRef(null);
  const records = Object.fromEntries((resource.data || []).map(item => [item.organ_id, item]));
  const left = ["eyes_ears", "mouth", "nervous_system", "breathing", "immune", "digestive", "dna"];
  const renderCard = organ => <OrganStatusCard key={organ.id} organ={organ} record={records[organ.id]}
    requestState={resource.status} active={hovered === organ.id} onActivate={setHovered} />;
  return <section ref={scene} className="dad-anatomy" aria-label="I tredici organi aziendali"><OrganConnections scene={scene} active={hovered} />
    <div className="dad-organ-column">{ORGAN_MAP.filter(o => left.includes(o.id)).map(renderCard)}</div>
    <div className="dad-body-stage">
      <div className="dad-map-caption"><span className="dad-eyebrow">Un organismo. Tredici funzioni.</span><p>Esplora un organo per entrare nella tua azienda.</p></div>
      <HumanBodyMap records={records} requestState={resource.status} active={hovered} onActivate={setHovered} />
      <p className="dad-map-note">La luce dell’anatomia è illustrativa.<br />Gli stati reali sono indicati nelle card e sui nodi.</p>
    </div>
    <div className="dad-organ-column">{ORGAN_MAP.filter(o => !left.includes(o.id)).map(renderCard)}</div>
  </section>;
}
